import React, { useState } from "react";

const FillMissing = ({
  paragraph = "",
  questionNumber = "",
  correctAnswers = [],
  onCalculateScore,
}) => {
  // Split the paragraph by placeholders ("______") while preserving new lines
  const parts = paragraph.split(/(_)/g);

  // Initialize state to store input values
  const [inputValues, setInputValues] = useState(
    Array(parts.filter((p) => p === "_").length).fill("")
  );

  // Handle input change
  const handleInputChange = (index, value) => {
    const updatedValues = [...inputValues];
    updatedValues[index] = value;
    setInputValues(updatedValues);
  };

  return (
    <div className="p-3 w-full bg-white font-inter border border-gray-300 rounded-md shadow-md">
      {/* Full Paragraph with Inputs */}
      <div className="text-sm text-gray-800 whitespace-pre-line leading-relaxed">
        {parts.map((part, index) => {
          if (part === "_") {
            // Find the corresponding index of the input
            const inputIndex = parts.slice(0, index).filter((p) => p === "_").length;
            return (
              <input
                key={index}
                type="text"
                className="inline-block w-24 h-8 border border-gray-400 px-2 text-sm rounded focus:outline-none focus:ring-1 focus:ring-blue-500 mx-1"
                placeholder="?"
                value={inputValues[inputIndex]}
                onChange={(e) => handleInputChange(inputIndex, e.target.value)}
              />
            );
          } else {
            // Convert text inside < and > to bold
            const formattedPart = part.replace(/<([^>]+)>/g, `<strong>$1</strong>`);
            return (
              <span key={index} dangerouslySetInnerHTML={{ __html: formattedPart }} />
            );
          }
        })}
      </div>

      {/* Finish Button */}
      <div className="mt-4 flex justify-end">
        <button
          className="w-28 h-10 bg-blue-500 text-white rounded-md flex items-center justify-center cursor-pointer hover:bg-blue-600 transition text-lg"
          onClick={() => onCalculateScore(1, questionNumber, inputValues, correctAnswers)}
        >
          Finish
        </button>
      </div>
    </div>
  );
};

export default FillMissing;
